import { render, staticRenderFns } from "./CommonConfigPage.vue?vue&type=template&id=18e9ea98&scoped=true"
import script from "./CommonConfigPage.vue?vue&type=script&lang=js"
export * from "./CommonConfigPage.vue?vue&type=script&lang=js"
import style0 from "./CommonConfigPage.vue?vue&type=style&index=0&id=18e9ea98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e9ea98",
  null
  
)

export default component.exports